import { jwtDecode } from "jwt-decode";

/* GET USER ID */
export const getCurrentUserId = () => {
  const token = localStorage.getItem("token");
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    console.log("Decoded JWT payload:", decoded);

    return decoded.id || decoded.userId;
  } catch (err) {
    console.error("Invalid token");
    return null;
  }
};

/* GET TOKEN */
export const getToken = () => {
  return localStorage.getItem("token");
};

/* REMOVE TOKEN */
export const removeToken = () => {
  localStorage.removeItem("token");
};

/* CHECK TOKEN EXPIRY */
export const isTokenExpired = (token) => {
  try {
    const decoded = jwtDecode(token);

    // exp is in seconds → convert to ms
    return decoded.exp * 1000 < Date.now();
  } catch (err) {
    return true; // invalid token = treat as expired
  }
};
